import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/css/app.scss'
import './assets/css/project.scss'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/material.css'
import jquery from 'jquery'
import underscore from 'vue-underscore'
import 'vue-loading-overlay/dist/vue-loading.css'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import VueWorker from 'vue-worker'
import StoreProcPlugin from './share/service/plugin/StoreProcPlugin'
import AppLib from './share/AppLib'
import { sync } from 'vuex-router-sync'
import VueClipboard from 'vue-clipboard2'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-250694063-1', // 운영서버
  // id: 'UA-250479969-1'(개발서버), // 콘솔에서 본인의 키를 확인하세요!
  router // 원활한 트래킹을 위해 router를 꼭 바인드 해 주어야 합니다!
})
VueClipboard.config.autoSetContainer = true // add this line
sync(store, router)

Vue.use(VueClipboard)
Vue.use(StoreProcPlugin)
Vue.use(VueWorker)
Vue.prototype.$Q = jquery
const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    timeout: 5000
  }
}
Vue.use(Snotify, options)
Vue.use(underscore)
Vue.config.productionTip = false
// global pipe
Vue.filter('comma', function (value) {
  if (value === undefined || value === null) return null
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})
Vue.filter('yyyyMMdd', function (value) {
  if (value === null) {
    return
  }
  let date = AppLib.formatDateFromTimeStamp(value)
  let mm = parseInt(date.substring(5, 7))
  let dd = parseInt(date.substring(8, 10))
  return `${date.substring(0, 4)}년 ${mm}월 ${dd}일`
})
Vue.filter('MMdd', function (value) {
  if (value === null) {
    return
  }
  let date = AppLib.formatDateFromTimeStamp(value)
  let mm = parseInt(date.substring(5, 7))
  let dd = parseInt(date.substring(8, 10))
  return `${mm}월 ${dd}일`
})
Vue.filter('yyyyMM', function (value) {
  if (value === null) {
    return
  }
  let date = AppLib.formatDateFromTimeStamp(value)
  let mm = parseInt(date.substring(5, 7))
  return `${date.substring(0, 4)}년 ${mm}월`
})
Vue.filter('MM', function (value) {
  if (value === null) {
    return
  }
  let date = AppLib.formatDateFromTimeStamp(value)
  let mm = parseInt(date.substring(5, 7))
  return `${mm}월`
})
Vue.filter('hyphenTelNo', function (value) {
  if (value.substring(0, 2) === '02') {
    if (value.length === 9) {
      return `${value.substring(0, 2)}-${value.substring(2, 5)}-${value.substring(5, 9)}`
    } else if (value.length > 9) {
      return `${value.substring(0, 2)}-${value.substring(2, 6)}-${value.substring(6, value.length)}`
    } else {
      return value
    }
  } else {
    if (value.length === 10) {
      return `${value.substring(0, 3)}-${value.substring(3, 6)}-${value.substring(6, 10)}`
    } else if (value.length > 10) {
      return `${value.substring(0, 3)}-${value.substring(3, 7)}-${value.substring(7, value.length)}`
    } else {
      return value
    }
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
